import styled from "styled-components";
import { Box, Card } from "@mui/material";

export const AffiliateContainer = styled(Box)`
	.affiliate-tabs {
		border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
		.MuiTab-root {
			font-weight: bold;
			text-transform: none;
		}
		.Mui-selected {
			color: ${({ theme }) => theme.custom_palette.color1} !important;
		}
		.MuiTabs-indicator {
			background-color: ${({ theme }) => theme.custom_palette.color1};
		}
	}
`;

export const StatWrapper = styled(Card)<{ $statColor: string }>`
	padding: 16px 18px;
	display: flex;
	align-items: flex-start;
	gap: 14px;
	flex: 1;
	min-width: 185px;
	border-left: 4px solid ${({ $statColor }) => $statColor} !important;

	${props => props.theme.breakpoints.down("md")} {
		width: 100%;
	}

	.icon {
		width: 44px;
		height: 44px;
		border-radius: 10px;
		background: ${({ $statColor }) => $statColor}22;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;

		svg {
			fill: ${({ $statColor }) => $statColor};
			font-size: 20px;
		}
	}

	.stats {
		display: flex;
		flex-direction: column;
	}
`;
